module.exports = __webpack_public_path__ + "img/success.20ad5c1.png";